import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const CUSTOM_LINK_CLASS_NAME = 'custom-link';

/*
  * This component is used to handle standard HTML links (e.g. in ag-grid renderers that are not react components).
 */
export const CustomLinksHandler = () => {
  const history = useHistory();
  const eventHandler = useCallback((event: MouseEvent) => {
    const target = event.target as HTMLElement | null;
    if (target && target.classList.contains(CUSTOM_LINK_CLASS_NAME)) {
      event.preventDefault();
      const to = target.getAttribute('href');
      if (to) {
        history.push(to);
      }
    }
  }, [history]);

  useEffect(() => {
    window.addEventListener('click', eventHandler);
    return () => window.removeEventListener('click', eventHandler);
  }, [eventHandler]);

  return null;
};
